import React from "react";
import { motion } from "framer-motion";
import { FaCode, FaUsers, FaRocket, FaShieldAlt } from "react-icons/fa";
import "./About.css";

const cards = [
  {
    icon:  <FaCode />,
    color: "var(--accent)",
    title: "Desarrollo",
    text:  "Stack moderno con React, Next.js y Node.js. Código limpio, escalable y bien documentado.",
  },
  {
    icon:  <FaUsers />,
    color: "var(--violet)",
    title: "Servicios",
    text:  "Soluciones a medida: web scraping, automatización Python, APIs y aplicaciones móviles.",
  },
  {
    icon:  <FaRocket />,
    color: "var(--cyan)",
    title: "Escalabilidad",
    text:  "Arquitecturas preparadas para crecer. Deploy en la nube con CI/CD y buenas prácticas DevOps.",
  },
  {
    icon:  <FaShieldAlt />,
    color: "var(--emerald)",
    title: "Calidad",
    text:  "Código revisado, testing automatizado y seguridad como prioridad en cada entrega.",
  },
];

const About = React.memo(function About() {
  return (
    <section id="about" className="about">
      <div className="container">

        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="section-label">Quiénes somos</span>
          <h2 className="section-title">Sobre NexoCode</h2>
          <p className="section-subtitle">
            Desarrollamos soluciones digitales modernas enfocadas en rendimiento,
            escalabilidad y buenas prácticas. Productos que aportan valor real.
          </p>
        </motion.div>

        <div className="about-grid">
          {cards.map((card, i) => (
            <motion.div
              key={card.title}
              className="about-card glass-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ delay: i * 0.1, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}
              style={{ "--card-color": card.color }}
            >
              <span className="about-icon-wrap">{card.icon}</span>
              <h3 className="about-card-title">{card.title}</h3>
              <p className="about-card-text">{card.text}</p>
              <div className="about-card-bar" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default About;
